import { EntityPicker, EntityItem } from '@features/entity-picker'
import { useEmployees } from '@hooks/useEmployee'
import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { useManagedGroupOutletContext } from '../ManagedGroup'

export const UserPicker = memo(() => {
  const {
    handleEmployeeClick: handleClick,
    selectedWorkerIds: selectedIds,
    workers: { search, setSearch },
  } = useManagedGroupOutletContext()

  const { t } = useTranslation()

  return (
    <div className="flex flex-col">
      <p className="text-xs font-medium text-neutral-500 mb-2">
        {t('features.adminManagedGroups.workersIncludedInGroup', {
          count: selectedIds.size,
        })}
      </p>
      <EntityPicker
        className="min-w-[300px]"
        filter={(employee, search) => {
          const s = search.toLowerCase()
          return employee.fullName.toLowerCase().includes(s)
        }}
        placeholder={t('common.search')}
        isSelected={(employee, selectedIds) =>
          selectedIds.has(employee.workdayWorkerId)
        }
        renderNoItemSelected={() => (
          <p className="text-xs text-neutral-500">
            {t('features.adminManagedGroups.noWorkersSelected')}
          </p>
        )}
        renderSearchItem={(employee) => {
          const isDisabled = () => {
            if (selectedIds.has(employee.workdayWorkerId)) return true
            /**
             * the following is an overly cautious check to ensure that the
             * employee is not already in another group. If the api returns
             * its type properly (i.e. adminManagedGroup is always defined),
             * this check is too much.  Since the API is a work in progress at
             * this point, I'm placing this here
             *
             * It won't hurt to leave this here even after the api is properly
             * returning a proper type
             *
             * - AF 3/24/25
             */
            if ((employee.adminManagedGroup?.id ?? null) === null) return false

            return true
          }

          return (
            <EntityItem
              key={employee.workdayWorkerId}
              onClick={() => handleClick(employee, { selected: true })}
              primaryText={employee.fullName}
              disabled={isDisabled()}
            />
          )
        }}
        renderSelectedItem={(employee) => (
          <EntityItem
            key={employee.workdayWorkerId}
            onClick={() => handleClick(employee, { selected: false })}
            primaryText={employee.fullName}
            removable={true}
          />
        )}
        selectedIds={selectedIds}
        useState={() => [search, setSearch]}
        useQuery={useEmployees}
      />
    </div>
  )
})

UserPicker.displayName = 'UserPicker'
